import type { ReactNode } from "react";
import { FaceoffCircle } from "../rink/FaceoffCircle";

export interface EmptyStateProps {
  /** One sentence saying what is missing and why it matters. */
  children: ReactNode;
  /** The single next action, usually a Button. */
  action?: ReactNode;
}

/** Empty state: a faceoff circle, one sentence, and the next action. */
export function EmptyState({ children, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-panel border border-dashed border-edge bg-board/60 px-6 py-10 text-center">
      <FaceoffCircle className="size-20" />
      <p className="max-w-prose text-operate text-ink-2">{children}</p>
      {action}
    </div>
  );
}
